import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClientInputContent } from 'client/models';
import { InputControllerTypes } from 'common/enums';

@Component({
    selector: 'answer-type-field',
    templateUrl: './answer-type-field.component.html',
    styleUrls: ['answer-type-field.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AnswerTypeFieldComponent implements OnInit {

  @Input() inputContent!: ClientInputContent;
  @Input() formGroup!: FormGroup;
  @Input() hideLabel = false;

  public ControllerTypes = InputControllerTypes;

  constructor() { }

  ngOnInit() {
  }

}
